module.exports = __webpack_public_path__ + "img/device_am35_m_c.6e02b906.png";